import {createContext, useContext} from "react";
import type {TaxiOverviewResponse} from "@/api/apiClient";
import type {OrderDraft} from "@/features/order/utils/types";

export const OrderContext = createContext<{
    orderDraft: OrderDraft;
    setOrderDraft: (updater: OrderDraft | ((prev: OrderDraft) => OrderDraft)) => void;
    resetOrderDraft: () => void;
    overview: TaxiOverviewResponse | undefined;
    isViableRoute: boolean;
} | null>(null);

export const useOrderContext = () => {
    const context = useContext(OrderContext);
    if (!context) {
        throw new Error("useOrderContext must be used within an OrderProvider");
    }

    const {setOrderDraft, ...rest} = context;

    const updateOrderDraft = (data: Partial<OrderDraft>) => {
        setOrderDraft((prev) => ({...prev, ...data}));
    };

    return {...rest, setOrderDraft, updateOrderDraft};
};
